import { render, staticRenderFns } from "./MultipleResponseView.vue?vue&type=template&id=840227a4"
import script from "./MultipleResponseView.vue?vue&type=script&lang=js"
export * from "./MultipleResponseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports